var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment__header"},[_c('p',[_vm._v("コメント")]),_vm._v(" "),_c('button',{staticClass:"comment__close js-comment-close",on:{"click":_vm.$parent.closeComment}},[_c('i',{staticClass:"las la-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }